import { render, staticRenderFns } from "./TokenNftHeaderMenu.vue?vue&type=template&id=f8c3e25a&scoped=true"
import script from "./TokenNftHeaderMenu.vue?vue&type=script&lang=ts"
export * from "./TokenNftHeaderMenu.vue?vue&type=script&lang=ts"
import style0 from "./TokenNftHeaderMenu.vue?vue&type=style&index=0&id=f8c3e25a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8c3e25a",
  null
  
)

export default component.exports